export const funFacts = [
  { fact: "Le miel ne se gâte jamais. Les archéologues ont trouvé des pots de miel dans des tombes égyptiennes antiques vieux de plus de 3 000 ans et encore parfaitement comestibles." },
  { fact: "Les poulpes ont trois cœurs et leur sang est bleu à cause d'une protéine riche en cuivre appelée hémocyanine." },
  { fact: "Les bananes sont des baies, mais les fraises ne le sont pas." },
  { fact: "Les requins sont plus anciens que les arbres. Ils existent depuis plus de 400 millions d'années." },
  { fact: "Un jour sur Vénus est plus long que son année." },
  { fact: "Votre cerveau utilise la même quantité d'énergie qu'une ampoule de 10 watts." },
  { fact: "Un groupe de flamants roses s'appelle une 'flamboyance'." },
  { fact: "Les vaches ont des meilleures amies et sont stressées quand elles sont séparées." },
  { fact: "La tour Eiffel peut être 15 cm plus haute en été à cause de la dilatation thermique." },
  { fact: "Les papillons peuvent goûter avec leurs pattes." },
  { fact: "On peut entendre pousser la rhubarbe. Elle fait de petits bruits de craquement dans les tiges." },
  { fact: "La majorité de votre cerveau est constituée de graisse — environ 60%." },
  { fact: "Les crottes de wombat sont cubiques pour les empêcher de rouler." },
  { fact: "Les humains partagent environ 60% de leur ADN avec les bananes." },
  { fact: "Le cœur d'une baleine bleue a la taille d'une petite voiture." },
  { fact: "Il y a plus d'étoiles dans l'univers que de grains de sable sur toutes les plages de la Terre." },
  { fact: "Les paresseux peuvent retenir leur respiration plus longtemps que les dauphins." },
  { fact: "Les chats ne peuvent pas goûter le sucré à cause d'une mutation génétique." },
  { fact: "L'odeur de l'herbe fraîchement coupée est en fait un appel de détresse de la plante." },
  { fact: "L'inventeur de la boîte Pringles est enterré dans une." },
  { fact: "Il existe une espèce de méduse biologiquement immortelle." },
  { fact: "Un nuage moyen pèse environ un million de livres." },
  { fact: "La lune a des tremblements de lune, comme la Terre a des tremblements de terre." },
  { fact: "Certaines tortues peuvent respirer par leurs fesses." },
  { fact: "Un seul brin de spaghetti s'appelle un 'spaghetto'." },
  { fact: "Vous ne pouvez pas fredonner en vous bouchant le nez." },
  { fact: "La fourrure de l'ours polaire est en fait transparente, pas blanche." },
  { fact: "Un éclair est cinq fois plus chaud que la surface du soleil." },
  { fact: "Il pleut des diamants sur Jupiter et Saturne." },
  { fact: "Le point sur les lettres 'i' et 'j' s'appelle un 'tittle'." },
  { fact: "Certains champignons créent des zombies en infectant les insectes." },
  { fact: "L'eau chaude gèle plus vite que l'eau froide — c'est l'effet Mpemba." },
  { fact: "Les requins sont immunisés contre presque toutes les maladies connues." },
  { fact: "Les avocats sont toxiques pour les oiseaux et de nombreux animaux domestiques." },
  { fact: "Le plus long épisode de hoquet a duré 68 ans." },
  { fact: "Le terme scientifique pour la sensation de froid au cerveau est ganglionévralgie sphéno-palatine." },
  { fact: "Les escargots peuvent dormir jusqu'à 3 ans." },
  { fact: "Vous ne pouvez pas vous chatouiller vous-même car votre cerveau prédit la sensation." },
  { fact: "Les koalas ont des empreintes digitales presque identiques à celles des humains." },
  { fact: "Les éléphants pleurent leurs morts et organisent même des funérailles." },
  { fact: "Il existe un virus informatique nommé d'après un Pokémon : Pikachu." },
  { fact: "La première webcam surveillait une cafetière à l'Université de Cambridge." },
  { fact: "Facebook est bleu parce que Mark Zuckerberg est daltonien rouge-vert." },
  { fact: "La vitesse internet de la NASA peut atteindre jusqu'à 91 gigabits par seconde." },
  { fact: "Le mot 'robot' vient d'un mot tchèque signifiant 'travail forcé'." },
  { fact: "Le premier email a été envoyé par Ray Tomlinson à lui-même en 1971." },
  { fact: "Taper 'Google' dans Google cassait certains navigateurs anciens." },
  { fact: "Les souris d'ordinateur étaient faites en bois dans les années 1960." },
  { fact: "Le clavier QWERTY a été conçu pour ralentir les dactylographes." },
  { fact: "Tetris a été joué à bord de la Station spatiale internationale." },
  { fact: "Les crevettes ont le cœur dans la tête." },
  { fact: "Le chocolat était autrefois utilisé comme monnaie chez les Aztèques." },
  { fact: "Les fourmis n’ont pas de poumons." },
  { fact: "Les pingouins offrent des cailloux pour séduire leur partenaire." },
  { fact: "Les étoiles de mer n'ont pas de cerveau." },
  { fact: "Les dauphins ont des noms qu’ils se donnent entre eux." },
  { fact: "Les corbeaux peuvent se souvenir de visages humains et s’en souvenir pendant des années." },
  { fact: "Les girafes dorment moins de 2 heures par jour." },
  { fact: "Le manchot empereur peut retenir sa respiration plus de 20 minutes sous l’eau." },
  { fact: "Les abeilles peuvent reconnaître des visages humains." },
  { fact: "Les grenouilles peuvent geler l’hiver et revenir à la vie au printemps." },
  { fact: "Les loutres dorment en se tenant la main pour ne pas dériver." },
  { fact: "Les hippocampes mâles portent les bébés." },
  { fact: "Le caméléon ne change pas de couleur pour se camoufler, mais pour communiquer." },
  { fact: "La langue du caméléon peut être deux fois plus longue que son corps." },
  { fact: "Les cigales peuvent rester sous terre pendant 17 ans avant de ressortir." },
  { fact: "Le panda passe jusqu’à 14 heures par jour à manger du bambou." },
  { fact: "Les moustiques sont attirés par les gens qui viennent de manger des bananes." },
  { fact: "Les escargots ont 14 000 dents disposées sur une sorte de râpe." },
  { fact: "Les zèbres ont tous un motif de rayures unique, comme une empreinte digitale." },
  { fact: "Les chauves-souris tournent toujours à gauche en sortant d’une grotte." },
  { fact: "Les koalas dorment jusqu’à 22 heures par jour." },
  { fact: "Le poulpe peut changer de texture en plus de sa couleur." },
  { fact: "Les hippocampes sont monogames et dansent ensemble chaque matin." },
  { fact: "Certains papillons boivent les larmes des crocodiles." },
  { fact: "Les chauves-souris peuvent manger jusqu’à 1 200 moustiques par heure." },
  { fact: "Les grenouilles avalent avec les yeux : ils les rétractent pour pousser la nourriture dans la gorge." },
  { fact: "Le poisson-lune peut pondre jusqu’à 300 millions d'œufs à la fois." },
  { fact: "Un canard peut être entendu jusqu’à 1,6 km de distance." },
  { fact: "Les flamants roses sont blancs à la naissance ; leur couleur vient de leur alimentation." },
  { fact: "Les rats rient quand on les chatouille." },
  { fact: "La crevette-mante peut frapper avec la vitesse d'une balle de calibre .22." },
  { fact: "Le tardigrade peut survivre dans le vide de l’espace." },
  { fact: "Le cri du crocodile ressemble à un rugissement." },
  { fact: "Les fourmis peuvent transporter jusqu’à 50 fois leur propre poids." },
  { fact: "Les paons font vibrer leurs plumes pour séduire." },
  { fact: "Les méduses n’ont ni cerveau, ni cœur, ni os." },
  { fact: "Les girafes n’ont que sept vertèbres cervicales, comme les humains." },
  { fact: "Le serpent peut sentir avec sa langue." },
  { fact: "Le colibri est le seul oiseau capable de voler à reculons." },
  { fact: "Les abeilles dansent pour indiquer la direction d'une source de nectar." },
  { fact: "Les manchots peuvent sauter jusqu’à 2 mètres de haut." },
  { fact: "Un mille-pattes n’a pas forcément mille pattes." },
  { fact: "Le cœur du colibri peut battre jusqu’à 1 200 fois par minute." },
  { fact: "Certains poissons peuvent changer de sexe au cours de leur vie." },
  { fact: "Les poulpes rêvent pendant leur sommeil." },
  { fact: "Le kangourou ne peut pas reculer." },
  { fact: "Les serpents peuvent dormir les yeux ouverts." },
  { fact: "Les narvals sont les licornes des mers, leur corne est une dent torsadée." }
];